import React from 'react';
import { UrlCollection } from "../common/url-collection";
import LayoutView from "../components/layout/layout.view";
import UserManagement from "../modules/user-management/user-management.view";
import UserLogHistory from "../modules/user-log/user-log-history.view";
import MyAccount from "../modules/my-account/my-account.view.jsx";

const wrapLayout = (title, Component) => () => (
    <LayoutView title={title}>
        <Component />
    </LayoutView>
);

export const adminRoutes = [
    {
        path: UrlCollection.UserManagement,
        component: UserManagement,
        layout: wrapLayout("Quản lý người dùng", UserManagement),
        exact: true
    },
    {
        path: UrlCollection.UserLogHistory,
        component: UserLogHistory,
        layout: wrapLayout("Nhật ký người dùng", UserLogHistory),
        exact: true
    },
    {
        path: UrlCollection.MyAccount,
        component: MyAccount,
        layout: wrapLayout("", MyAccount),
        exact: true
    }
];
